import { s, d } from '../Reducers/Lang';

export { s, d };
